import { render } from "./ClientAddAvailableScopeModal.vue?vue&type=template&id=d53555e8"
import script from "./ClientAddAvailableScopeModal.vue?vue&type=script&lang=js"
export * from "./ClientAddAvailableScopeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__